import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { SlotExtended, SlotExtendedListResponse, SlotQueryParams } from '@frontend/slot/types';

const endpoint = '/slot-api/ext/v1';
export class SlotExtendedClient extends APIClient {
    public static async fetchSlotExtendeds(queryParams?: ApiQueryParams<SlotQueryParams>): Promise<SlotExtendedListResponse> {
        return this.apiPaginated<SlotExtendedListResponse, SlotQueryParams>(`${endpoint}/slots`, queryParams);
    }

    public static async fetchSlotExtended(accountId: string, spotId: string, moduleId: string, slotId: string): Promise<SlotExtended> {
        const response = await this.fetch(`${endpoint}/accounts/${accountId}/spots/${spotId}/modules/${moduleId}/slots/${slotId}`);
        return await this.handleResponse<SlotExtended>(response);
    }
}
